<template>
  <SogFlexRow>
    <SogCard v-show="_kzkGermanyPrices.length">
      <SogCardTitle>
        Kurzzeitkennzeichen Deutschland
      </SogCardTitle>
      <SogCardContent
        v-for="item in _kzkGermanyPrices"
        :key="item"
      >
        <ProductPriceCardComponent
          :price="item"
          :is-selected="isSelected(item)"
          :allow-select="allowSelect"
          @click="onClick(item)"
        />
      </SogCardContent>
    </SogCard>
    <SogCard v-show="_kzkIvkPrices.length">
      <SogCardTitle>
        Kurzzeitkennzeichen IVK
      </SogCardTitle>
      <SogCardContent
        v-for="item in _kzkIvkPrices"
        :key="item"
      >
        <ProductPriceCardComponent
          :price="item"
          :is-selected="isSelected(item)"
          :allow-select="allowSelect"
          @click="onClick(item)"
        />
      </SogCardContent>
    </SogCard>
    <SogCard v-show="_exportPrices.length">
      <SogCardTitle>
        Ausfuhrkennzeichen
      </SogCardTitle>
      <SogCardContent
        v-for="item in _exportPrices"
        :key="item"
      >
        <ProductPriceCardComponent
          :price="item"
          :is-selected="isSelected(item)"
          :allow-select="allowSelect"
          @click="onClick(item)"
        />
      </SogCardContent>
    </SogCard>
    <SogCard v-show="_tzPrices.length">
      <SogCardTitle>
        Tageszulassung
      </SogCardTitle>
      <SogCardContent
        v-for="item in _tzPrices"
        :key="item"
      >
        <ProductPriceCardComponent
          :price="item"
          :is-selected="isSelected(item)"
          :allow-select="allowSelect"
          @click="onClick(item)"
        />
      </SogCardContent>
    </SogCard>
    <SogCard v-show="_exportBlankPrices.length">
      <SogCardTitle>
        Ausfuhrformulare
      </SogCardTitle>
      <SogCardContent
        v-for="item in _exportBlankPrices"
        :key="item"
      >
        <ProductPriceCardComponent
          :price="item"
          :is-selected="isSelected(item)"
          :allow-select="allowSelect"
          @click="onClick(item)"
        />
      </SogCardContent>
    </SogCard>
    <SogCard v-show="_additionPrices.length">
      <SogCardTitle>
        Gebühren
      </SogCardTitle>
      <SogCardContent>
        <ProductPriceCardComponent
          v-for="item in _additionPrices"
          :key="item"
          :price="item"
          :is-selected="isSelected(item)"
          :allow-select="allowSelect"
          @click="onClick(item)"
        />
      </SogCardContent>
    </SogCard>
    <SogCard v-show="_restPrices.length">
      <SogCardTitle>
        Diverse
      </SogCardTitle>
      <SogCardContent>
        <ProductPriceCardComponent
          v-for="item in _restPrices"
          :key="item"
          :price="item"
          :is-selected="isSelected(item)"
          :allow-select="allowSelect"
          @click="onClick(item)"
        />
      </SogCardContent>
    </SogCard>
  </SogFlexRow>
</template>

<script setup lang="ts">
import {ref,} from "vue";
import ProductPrice from "@/shared/model/productPrice";
import ProductPriceCardComponent from "@/modules/OrganisationStructure/components/ProductPriceCardComponent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {computed} from "vue";
import {ProductType} from "@/shared/model/productType";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import {TerritoryType} from "@/shared/model/territoryType";

interface Props {
  id?: string
  prices?: ProductPrice[]
  allowSelect?: boolean | string
  selected?: (item?: ProductPrice) => void,
}

const props = withDefaults(defineProps<Props>(), {
    id: undefined, prices: undefined, allowSelect: undefined, isSelected: undefined, selected: undefined
  }
)

const _selectedId = ref<string | undefined>(undefined)

function onClick(price: ProductPrice) {
  if (!props.allowSelect)
    return
  const res = _selectedId.value === price.id ? undefined : price
  _selectedId.value = res?.id
  if (props.selected) {
    props.selected(res)
  }
}

function isSelected(item: ProductPrice): boolean {
  return item.id === _selectedId.value
}

const _kzkIvkPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Kzk && t.territoryTypeId === TerritoryType.Eu)
})
const _kzkGermanyPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Kzk && t.territoryTypeId === TerritoryType.Germany)
})
const _exportPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Zoll)
})
const _tzPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Tz)
})

const _additionPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.Addition)
})

const _exportBlankPrices = computed(() => {
  return props.prices?.filter(t => t.productTypeId === ProductType.ExportBlank)
})

const _restPrices = computed(() => {
  return props.prices?.filter(t => ![ProductType.Addition, ProductType.Tz, ProductType.Zoll, ProductType.Kzk, ProductType.ExportBlank].some(p => p === t.productTypeId))
})


/*
watch(props,()=>{
    _tab.value?.hideTab(_tabIndexPurchase,!props.visiblePurchase)
    _tab.value?.hideTab(_tabIndexSale,!props.visibleSale)
    _salePrices.length = 0;
    _purchasePrices.length = 0;
    _salePrices.push(...props.salePrices??[])
    _purchasePrices.push(...props.purchasePrices??[])
  tabSelected(props.visiblePurchase?_tabIndexPurchase:_tabIndexSale)
},{immediate:true}
)
*/

</script>

<style>

</style>
